/**
 * Selected-state indicator: a small left accent bar in the beacon color. The
 * one canonical "this item is selected" mark (sidebar, segmented lists).
 *
 * Sizeless core (position + width + color). Each consumer adds the height:
 *   sidebar item: cn(SELECTION_BAR, 'top-1/2 h-4 -translate-y-1/2')
 *   tall row:     cn(SELECTION_BAR, 'inset-y-2')
 */
export const SELECTION_BAR = 'absolute left-0 w-[3px] rounded-r-full bg-signal';
